import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-273c5d9e")

_pushScopeId("data-v-273c5d9e")
const _hoisted_1 = { class: "form-time-input relative" }
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = {
  class: "time--item mt-1",
  ref: "timeOption"
}
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "hh--content mr-2" }
const _hoisted_6 = { class: "ss--content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Input = _resolveComponent("Input")
  const _directive_click_outside = _resolveDirective("click-outside")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["flex", _ctx.disabled ? 'pointer-events-none' : '']
    }, [
      _createVNode(_component_Input, {
        style: _ctx.style,
        onClick: _ctx.toggleTimeOption,
        placeholder: _ctx.placeholder,
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
        required: _ctx.required,
        validated: _ctx.validated,
        disabled: _ctx.disabled,
        "icon-prepend": 
          _ctx.isShowTimeSelected ? 'cp-icon-chevron-up' : 'cp-icon-chevron-down'
        ,
        errors: _ctx.errorMessage,
        "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errorMessage = $event)),
        "error-server": _ctx.errorServer,
        onChange: _ctx.onChangeInput
      }, null, 8, ["style", "onClick", "placeholder", "modelValue", "required", "validated", "disabled", "icon-prepend", "errors", "error-server", "onChange"]),
      _createVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array(24).keys(), (item) => {
            return (_openBlock(), _createBlock("div", {
              key: item,
              class: ["hh--item", _ctx.hour === item ? 'selected' : ''],
              onClick: ($event: any) => (_ctx.chooseHour(item))
            }, _toDisplayString(item), 11, ["onClick"]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array(60).keys(), (item) => {
            return (_openBlock(), _createBlock("div", {
              key: item,
              class: ["ss--item", _ctx.minutes === item ? 'selected' : ''],
              onClick: ($event: any) => (_ctx.chooseMinutes(item))
            }, _toDisplayString(item), 11, ["onClick"]))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, _ctx.isShowTimeSelected]
    ])
  ], 512)), [
    [_directive_click_outside, _ctx.clickOutside]
  ])
})